import {
  type IBasicUser,
  type ICompaniesResponse,
  type ICompanyData,
  IMetaWrapper,
} from '../../types'
import { useUpFetch } from '../../utils'

export const useCompanyApi = () => {
  const upFetch = useUpFetch()

  const getCompany = async (companyId: number) => {
    return upFetch<ICompanyData>(`/companies/${companyId}`)
  }

  const getCompanyBySlug = async (slug: string) => {
    return upFetch<ICompanyData>(`/companies?filter[slug]=${slug}`)
  }

  const getCompanyBySearchTerm = async (searchTerm: string) => {
    return upFetch<ICompaniesResponse>(`/companies?search=${searchTerm}`)
  }

  const getCompaniesList = async (company_name?: string) => {
    return upFetch<ICompaniesResponse>('/companies', {
      params: {
        i: 'account',
        perPage: '100',
        search: company_name,
      },
    })
  }

  const getCompanyMembers = async (companyId?: number) => {
    return upFetch<IMetaWrapper<IBasicUser>>(`/companies/${companyId}/members`)
  }

  return {
    getCompaniesList,
    getCompany,
    getCompanyBySearchTerm,
    getCompanyBySlug,
    getCompanyMembers,
  }
}
